import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 404 — a Codex 404-ének mása (404.html sablon, 2026-10-04): óriás „404” a lila középső számmal, rövid mondat,
 * két kiút a bot oldalán belül. Csak belépve látszik (kilépve minden cím a belépésre visz).
 */
export default function NotFoundPage() {
  return (
    <section className="relative overflow-hidden pt-[120px] pb-[140px]">
      <div className="wrap relative flex flex-col items-center gap-5 text-center">
        <span className="eyebrow"><span className="led bg-gray-500" />Error 404</span>
        <h1 className="font-bold uppercase leading-[0.95] tracking-[-0.045em] text-[#f7f7f9] text-[clamp(96px,20vw,220px)]">
          4<span className="text-brand-500">0</span>4
        </h1>
        <p className="max-w-[540px] text-[clamp(16px,1.6vw,19px)] leading-[1.55] text-gray-400 [text-wrap:balance]">
          This page does not exist. The link may be old, or the page was moved.
        </p>
        <div className="mt-1 flex flex-wrap justify-center gap-3">
          <Link to="/licence" className="btn-primary btn-lg">Dashboard <span className="btn-arrow">→</span></Link>
          <Link to="/docs" className="btn-glass btn-lg">Docs</Link>
        </div>
      </div>
    </section>
  );
}
